// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type PlusIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from plus.svg
 */
export default function PlusIcon(props: PlusIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="PlusIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M8.993 2.867 9 3v3.999L13 7a1 1 0 0 1 .117 1.993L13 9H9v4c0 1.287-1.864 1.332-1.993.133L7 13V9H3a1 1 0 0 1-.117-1.993L3 7h4V3c0-1.287 1.864-1.332 1.993-.133"
        />
      </g>
    </svg>
  );
}
